// components/dashboard/ActivitySection.jsx
import React from 'react';
import { Clock } from 'lucide-react';

const ActivityItem = ({ activity }) => (
    <div className="flex items-start space-x-3 p-3 bg-[#F4F8E9] rounded-lg">
        <div className="p-2 bg-white rounded-full">
            <Clock className="w-4 h-4 text-[#96B734]" />
        </div>
        <div>
            <p className="text-sm font-medium text-[#437011]">{activity.type}</p>
            <p className="text-sm text-gray-600">{activity.message}</p>
            <p className="text-xs text-gray-400 mt-1">{activity.time}</p>
        </div>
    </div>
);

const ActivitySection = () => {
    const activities = [
        { type: 'Réservation', message: 'Vol Niamey-Paris confirmé', time: 'Il y a 2h' },
        { type: 'Document', message: 'Passeport ajouté', time: 'Il y a 1j' },
        { type: 'Paiement', message: 'Transaction réussie', time: 'Il y a 2j' }
    ];

    return (
        <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-[#437011] flex items-center mb-6">
                <Clock className="w-6 h-6 mr-2" />
                Activités Récentes
            </h2>
            <div className="space-y-4">
                {activities.map((activity, index) => (
                    <ActivityItem key={index} activity={activity} />
                ))}
            </div>
        </div>
    );
};

export default ActivitySection;